const VocCountry = () => import('@/views/public/tourist/voc/VocCountry')
const ProportionChannels = () => import('@/views/public/tourist/voc/ProportionChannels')
const ProportionPurpose = () => import('@/views/public/tourist/voc/ProportionPurpose')

const mainWidget = [
  {
    title: 'แผนที่แสดงคำสนทนาด้านท่องเที่ยวในแต่ละจังหวัด (VOC)',
    path: '/public/widget/:category/:widget_code(29)',
    component: VocCountry
  },
  {
    title: 'ช่องทาง Social Media หลักในการสื่อสาร/ประชาสัมพันธ์',
    path: '/public/widget/:category/:widget_code(31)',
    component: ProportionChannels
  },
  {
    title: 'ความมุ่งหมายของคำสนทนาใน Social Media',
    path: '/public/widget/:category/:widget_code(32)',
    component: ProportionPurpose
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})